var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-navbar",
        {
          staticStyle: {
            background: "#0050b3 !important",
            "box-shadow": "0px 4px 4px rgb(0 0 0 / 20%)",
            padding: "0px 10px",
          },
          attrs: { toggleable: "lg", type: "dark", variant: "info" },
        },
        [
          _c("b-navbar-brand", { attrs: { href: "#" } }, [
            _vm._v("Welcome, Demo nha"),
          ]),
          _vm._v(" "),
          _c("el-button", { attrs: { type: "primary", loading: true } }, [
            _vm._v("Đang xuất công văn vui lòng đợi ..."),
          ]),
          _vm._v(" "),
          _c("b-navbar-brand", { attrs: { href: "#" } }, [
            _c(
              "div",
              { staticClass: "userconfix" },
              [
                _c("span", [
                  _vm._v(_vm._s(this.full_name)),
                  _c("br"),
                  _vm._v(" "),
                  _c("span", [_vm._v("Phòng Kế hoạch Tài chính")]),
                ]),
                _vm._v(" "),
                _c(
                  "el-popover",
                  {
                    staticStyle: { width: "max-content" },
                    attrs: {
                      trigger: "hover",
                      placement: "bottom",
                      "popper-class": "popover_btn_persInfo",
                    },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: {
                          width: "100%",
                          padding: "8px",
                          margin: "0px",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.hanlderPushPresonInFor()
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticStyle: { height: "22px" },
                          attrs: {
                            src: require("../../../../content/icon/per-info.svg"),
                          },
                        }),
                        _c("span", { staticStyle: { "margin-left": "5px" } }, [
                          _vm._v("Thông tin tài khoản"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticStyle: { "margin-top": "8px" } },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: {
                              width: "100%",
                              padding: "8px",
                              margin: "0px",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.logOut()
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticStyle: {
                                height: "22px",
                                float: "left",
                                "margin-right": "5px",
                              },
                              attrs: {
                                src: require("../../../../content/icon/exit.svg"),
                              },
                            }),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  float: "left",
                                  margin: "4px 50px 0 5px",
                                },
                              },
                              [_vm._v("Đăng xuất")]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("img", {
                      staticStyle: { height: "40px" },
                      attrs: {
                        slot: "reference",
                        "native-type": "submit",
                        src: require("../../../../content/images/user.png"),
                      },
                      slot: "reference",
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }